import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@p81-common/ui';

export default makeStyles<Theme>(theme => ({
  statusCell: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  autoAssignBadge: {
    ...theme.typography.caption1,
    display: 'inline-flex',
    alignItems: 'center',
    height: theme.spacing(2),
    padding: theme.spacing(0, 1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.secondary[100],
    color: theme.palette.secondary[700],
    border: `1px solid ${theme.palette.secondary[200]}`,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 1
  }
}));
